import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_KEY_STUDENT_HOME_USE_SETTING = gql`
  mutation updateKeyStudentSettingHomeUse($data: [UpdateKeyStudentSettingHomeUseInput!]!) {
    updateKeyStudentSettingHomeUse(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_KEY_STUDENT_HOME_USE_SETTING;
